const apiErrors = {
  name: { 'value is not unique': 'Sudah terdaftar di sistem.' },
}

export default apiErrors
